import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, ClipboardList, CalendarDays, Volleyball, Menu } from 'lucide-react';

const TABS = [
  { id: 'home', label: 'الرئيسية', icon: Home, path: '/venue-owner-dashboard' },
  { id: 'bookings', label: 'الحجوزات', icon: ClipboardList, path: '/venue-owner-dashboard/bookings' },
  { id: 'calendar', label: 'التقويم', icon: CalendarDays, path: '/venue-owner-dashboard/calendar' },
  { id: 'venues', label: 'الملاعب', icon: Volleyball, path: '/venue-owner-dashboard/venues' },
];

const isActive = (pathname, path) => pathname === path || (path !== '/venue-owner-dashboard' && pathname.startsWith(path + '/'));

export default function VenueOwnerMobileBottomNav({ onMore }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-lg lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="venue-owner-mobile-bottom-nav"
    >
      <div className="mx-auto flex max-w-lg items-center px-1">
        {TABS.map((tab) => {
          const active = isActive(location.pathname, tab.path);
          const TabIcon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              data-testid={`venue-owner-mobile-nav-${tab.id}`}
              className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 transition-transform active:scale-90"
            >
              <TabIcon className={`h-5 w-5 ${active ? 'text-orange-600' : 'text-slate-400'}`} strokeWidth={active ? 2.3 : 1.8} />
              <span className={`text-[10px] font-semibold ${active ? 'text-orange-600' : 'text-slate-400'}`}>{tab.label}</span>
            </button>
          );
        })}
        <button onClick={onMore} data-testid="venue-owner-mobile-nav-more" className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 transition-transform active:scale-90">
          <Menu className="h-5 w-5 text-slate-400" strokeWidth={1.8} />
          <span className="text-[10px] font-semibold text-slate-400">المزيد</span>
        </button>
      </div>
    </nav>
  );
}
